function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LibraryOverlayTemplate = require('./library.template');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var LibraryOverlay = /*#__PURE__*/function () {
  function LibraryOverlay(app) {
    var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, LibraryOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.file = null;
    this.file_name = '';
    this.game_data = null;
    this.busy = false;
    this.create_nft_overlay = null;
  }
  return _createClass(LibraryOverlay, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var opts,
          actions,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              this.busy = false;
              this.file = opts.file || null;
              this.file_name = opts.file_name || 'Selected ROM';
              this.game_data = opts.game_data || null;
              if (this.file) {
                _context.n = 1;
                break;
              }
              alert('No ROM selected.');
              return _context.a(2);
            case 1:
              _context.p = 1;
              if (this.game_data) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return this.mod.createGameData(this.file, this.file_name);
            case 2:
              this.game_data = _context.v;
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.log('Error building N-WASM game data: ' + _t);
              alert('Unable to prepare game data for library save.');
              return _context.a(2);
            case 5:
              actions = this.collect_actions();
              this.overlay.show(LibraryOverlayTemplate(actions));
              this.attach_events(actions);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4]]);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "collect_actions",
    value: function collect_actions() {
      var _this = this,
        _this$app$modules,
        _this$app$modules$get;
      var ctx = {
        file: this.file,
        file_name: this.file_name,
        game_data: this.game_data
      };
      var actions = [{
        id: 'local-archive',
        title: 'Save to Local Archive',
        description: 'Save your game locally.',
        image: '/nwasm/img/save_to_archive.png',
        rank: 10,
        callback: function () {
          var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, mod, context) {
            var _context$game_data;
            var tx;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return mod.saveGameToArchive(context.game_data);
                case 1:
                  tx = _context2.v;
                  _context2.n = 2;
                  return mod.addGame(tx, {
                    source: 'archive',
                    title: ((_context$game_data = context.game_data) === null || _context$game_data === void 0 ? void 0 : _context$game_data.name) || context.file_name
                  });
                case 2:
                  return _context2.a(2, {
                    source: 'archive',
                    tx: tx
                  });
              }
            }, _callee2);
          }));
          function callback(_x, _x2, _x3) {
            return _callback.apply(this, arguments);
          }
          return callback;
        }()
      }, {
        id: 'convert-nft',
        title: 'Convert to NFT',
        description: 'Create an on-chain NFT for your game.',
        image: '/nwasm/img/digitize_as_nft.png',
        rank: 30,
        callback: function () {
          var _callback2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, mod, context) {
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  _context3.n = 1;
                  return _this.open_create_nft(context);
                case 1:
                  return _context3.a(2, _context3.v);
              }
            }, _callee3);
          }));
          function callback(_x4, _x5, _x6) {
            return _callback2.apply(this, arguments);
          }
          return callback;
        }()
      }];
      var peers = ((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$get = _this$app$modules.getRespondTos) === null || _this$app$modules$get === void 0 ? void 0 : _this$app$modules$get.call(_this$app$modules, 'nwasm-library-actions', ctx)) || [];
      var _loop = function _loop() {
          var peer = peers[i];
          if (!(peer !== null && peer !== void 0 && peer.id) || !(peer !== null && peer !== void 0 && peer.title) || !(peer !== null && peer !== void 0 && peer.callback)) {
            return 0; // continue
          }
          if (actions.find(function (a) {
            return a.id === peer.id;
          })) {
            return 0; // continue
          }
          actions.push({
            id: peer.id,
            title: peer.title,
            description: peer.description || '',
            image: peer.image || '',
            rank: typeof peer.rank === 'number' ? peer.rank : 20,
            //
            // Wrap peer actions (Vault) so N-WASM always registers the resulting
            // game through addGame() before the Library re-renders.
            //
            callback: function () {
              var _callback3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, mod, context) {
                var result;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      _context4.n = 1;
                      return peer.callback(app, mod, context);
                    case 1:
                      result = _context4.v;
                      if (!(peer.id === 'vault-upload')) {
                        _context4.n = 3;
                        break;
                      }
                      _context4.n = 2;
                      return mod.addGameFromVaultResult(context, result || {});
                    case 2:
                      return _context4.a(2, {
                        source: 'vault',
                        result: result
                      });
                    case 3:
                      return _context4.a(2, result);
                  }
                }, _callee4);
              }));
              function callback(_x7, _x8, _x9) {
                return _callback3.apply(this, arguments);
              }
              return callback;
            }()
          });
        },
        _ret;
      for (var i = 0; i < peers.length; i++) {
        _ret = _loop();
        if (_ret === 0) continue;
      }
      actions.sort(function (a, b) {
        return (a.rank || 0) - (b.rank || 0);
      });
      return actions;
    }
  }, {
    key: "root",
    value: function root() {
      return document.querySelector('.nwasm-library');
    }
  }, {
    key: "wait_for_paint",
    value: function () {
      var _wait_for_paint = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return new Promise(function (resolve) {
                requestAnimationFrame(function () {
                  requestAnimationFrame(resolve);
                });
              });
            case 1:
              _context5.n = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 50);
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      function wait_for_paint() {
        return _wait_for_paint.apply(this, arguments);
      }
      return wait_for_paint;
    }()
  }, {
    key: "set_controls_enabled",
    value: function set_controls_enabled(enabled) {
      var root = this.root();
      if (!root) {
        return;
      }
      root.querySelectorAll('.choice').forEach(function (btn) {
        btn.disabled = !enabled;
        btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      });
    }
  }, {
    key: "set_progress_state",
    value: function set_progress_state() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$mode = _ref.mode,
        mode = _ref$mode === void 0 ? 'busy' : _ref$mode,
        _ref$lede = _ref.lede,
        lede = _ref$lede === void 0 ? 'Working…' : _ref$lede,
        _ref$status = _ref.status,
        status = _ref$status === void 0 ? 'Preparing…' : _ref$status,
        _ref$action_id = _ref.action_id,
        action_id = _ref$action_id === void 0 ? '' : _ref$action_id;
      var root = this.root();
      if (!root) {
        return;
      }
      this.busy = mode === 'busy';
      root.classList.toggle('is-busy', mode === 'busy');
      root.classList.toggle('is-success', mode === 'success');
      root.classList.toggle('is-error', mode === 'error');
      this.set_controls_enabled(mode === 'error');
      root.querySelectorAll('.choice').forEach(function (btn) {
        btn.classList.toggle('is-active', mode === 'busy' && !!action_id && btn.dataset.action === action_id);
      });
      var state = root.querySelector('.state');
      var lede_el = root.querySelector('.state .lede');
      var status_el = root.querySelector('.state .status');
      var choices = root.querySelector('.choices');
      if (choices) {
        //
        // Once a strategy has been chosen, keep the strategy cards hidden for
        // busy, success, and error. Do not return the user to strategy selection
        // on failure — they can close and start a new upload to choose again.
        //
        choices.hidden = true;
      }
      if (state) {
        state.hidden = false;
      }
      if (lede_el) {
        lede_el.textContent = lede;
      }
      if (status_el) {
        status_el.textContent = status;
      }
    }
  }, {
    key: "set_busy",
    value: function set_busy() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Saving…';
      var action_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.set_progress_state({
        mode: 'busy',
        lede: 'Saving…',
        status: message,
        action_id: action_id
      });
    }
  }, {
    key: "set_success",
    value: function set_success() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Saved to Local Archive';
      this.set_progress_state({
        mode: 'success',
        lede: 'Saved to Local Archive',
        status: message
      });
    }
  }, {
    key: "set_error",
    value: function set_error() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Unable to save. Please try again.';
      this.set_progress_state({
        mode: 'error',
        lede: 'Save failed',
        status: message
      });
    }
  }, {
    key: "success_copy",
    value: function success_copy() {
      var action_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (action_id === 'vault-upload') {
        return {
          lede: 'Uploaded to Vault',
          status: 'Your ROM is ready in the library.',
          toast: 'Game uploaded to Vault'
        };
      }
      if (action_id === 'convert-nft') {
        return {
          lede: 'Digitized as NFT',
          status: 'Your ROM is ready in the library.',
          toast: 'Game digitized as NFT'
        };
      }
      return {
        lede: 'Saved to Local Archive',
        status: 'Your ROM is ready in the library.',
        toast: 'Game saved to Local Archive'
      };
    }
  }, {
    key: "busy_copy",
    value: function busy_copy() {
      var action_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (action_id === 'local-archive') {
        return 'Saving to Local Archive…';
      }
      if (action_id === 'vault-upload') {
        return 'Uploading to Vault…';
      }
      if (action_id === 'convert-nft') {
        return 'Digitizing as NFT…';
      }
      return 'Working…';
    }
  }, {
    key: "refresh_library_ui",
    value: function () {
      var _refresh_library_ui = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this$mod$ui, _this$mod$arcade_over;
        var _this$mod$ui$show, _this$mod$ui2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!((_this$mod$ui = this.mod.ui) !== null && _this$mod$ui !== void 0 && _this$mod$ui.render)) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return this.mod.ui.render();
            case 1:
              (_this$mod$ui$show = (_this$mod$ui2 = this.mod.ui).show) === null || _this$mod$ui$show === void 0 || _this$mod$ui$show.call(_this$mod$ui2);
            case 2:
              if (!((_this$mod$arcade_over = this.mod.arcade_overlay) !== null && _this$mod$arcade_over !== void 0 && _this$mod$arcade_over.is_open)) {
                _context6.n = 3;
                break;
              }
              _context6.n = 3;
              return this.mod.arcade_overlay.refresh();
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function refresh_library_ui() {
        return _refresh_library_ui.apply(this, arguments);
      }
      return refresh_library_ui;
    }()
  }, {
    key: "attach_events",
    value: function attach_events() {
      var _this2 = this;
      var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var root = this.root();
      if (!root) {
        return;
      }
      var ctx = {
        file: this.file,
        file_name: this.file_name,
        game_data: this.game_data
      };
      var _loop2 = function _loop2() {
        var action = actions[i];
        var btn = root.querySelector("[data-action=\"".concat(action.id, "\"]"));
        if (!btn) {
          return 1; // continue
        }
        btn.onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(e) {
            var registers_library_game, copy, _t2;
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.p = _context7.n) {
                case 0:
                  e.preventDefault();
                  if (!_this2.busy) {
                    _context7.n = 1;
                    break;
                  }
                  return _context7.a(2);
                case 1:
                  registers_library_game = action.id === 'local-archive' || action.id === 'vault-upload' || action.id === 'convert-nft';
                  _context7.p = 2;
                  _this2.set_busy(_this2.busy_copy(action.id), action.id);
                  _context7.n = 3;
                  return _this2.wait_for_paint();
                case 3:
                  _context7.n = 4;
                  return action.callback(_this2.app, _this2.mod, ctx);
                case 4:
                  if (!registers_library_game) {
                    _context7.n = 8;
                    break;
                  }
                  // NFT / Vault may have hidden this overlay; restore for success UI.
                  _this2.ensure_overlay_visible(actions);
                  copy = _this2.success_copy(action.id);
                  _this2.set_progress_state({
                    mode: 'success',
                    lede: copy.lede,
                    status: copy.status
                  });
                  _context7.n = 5;
                  return _this2.wait_for_paint();
                case 5:
                  _context7.n = 6;
                  return _this2.refresh_library_ui();
                case 6:
                  _context7.n = 7;
                  return new Promise(function (resolve) {
                    return setTimeout(resolve, 1100);
                  });
                case 7:
                  _this2.overlay.hide();
                  siteMessage(copy.toast, 3000);
                  return _context7.a(2);
                case 8:
                  _this2.overlay.hide();
                  _context7.n = 10;
                  break;
                case 9:
                  _context7.p = 9;
                  _t2 = _context7.v;
                  console.log('Library action error: ' + _t2);
                  _this2.ensure_overlay_visible(actions);
                  _this2.set_error((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Unable to complete library action.');
                case 10:
                  return _context7.a(2);
              }
            }, _callee7, null, [[2, 9]]);
          }));
          return function (_x0) {
            return _ref2.apply(this, arguments);
          };
        }();
      };
      for (var i = 0; i < actions.length; i++) {
        if (_loop2()) continue;
      }
    }
  }, {
    key: "ensure_overlay_visible",
    value: function ensure_overlay_visible() {
      var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.root()) {
        return;
      }
      var list = actions || this.collect_actions();
      this.overlay.show(LibraryOverlayTemplate(list));
      this.attach_events(list);
    }
  }, {
    key: "open_create_nft",
    value: function () {
      var _open_create_nft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(ctx) {
        var _nft_cap$class,
          _this$mod$header,
          _this3 = this;
        var nft_cap, create_nft, CreateNFT;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              nft_cap = this.mod.respondTo('saito-create-nft');
              if (nft_cap !== null && nft_cap !== void 0 && (_nft_cap$class = nft_cap["class"]) !== null && _nft_cap$class !== void 0 && _nft_cap$class[0]) {
                _context9.n = 1;
                break;
              }
              throw new Error('N64 ROM NFT type is unavailable.');
            case 1:
              create_nft = ((_this$mod$header = this.mod.header) === null || _this$mod$header === void 0 || (_this$mod$header = _this$mod$header.select_nft_overlay) === null || _this$mod$header === void 0 ? void 0 : _this$mod$header.create_nft_overlay) || null;
              if (!create_nft) {
                if (!this.create_nft_overlay) {
                  CreateNFT = require('../../../../../lib/saito/ui/saito-nft/overlays/create-overlay');
                  this.create_nft_overlay = new CreateNFT(this.app, this.mod);
                }
                create_nft = this.create_nft_overlay;
              }

              //
              // Hide the choice cards while Create NFT runs, but keep this overlay's
              // promise open until mint finishes so we can addGame() before Library render.
              //
              this.overlay.hide();
              _context9.n = 2;
              return new Promise(function (resolve, reject) {
                create_nft.render({
                  type: nft_cap["class"][0],
                  quantity: 1,
                  locked: ['type', 'quantity'],
                  file: ctx.game_data.file,
                  file_name: ctx.file_name || ctx.game_data.name,
                  callback: function () {
                    var _callback4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(result) {
                      var _ctx$game_data, _t3;
                      return _regenerator().w(function (_context8) {
                        while (1) switch (_context8.p = _context8.n) {
                          case 0:
                            _context8.p = 0;
                            if (!(!result || result.status === 'cancelled')) {
                              _context8.n = 1;
                              break;
                            }
                            reject(new Error('NFT creation cancelled'));
                            return _context8.a(2);
                          case 1:
                            if (!(result.status !== 'created' || !result.tx)) {
                              _context8.n = 2;
                              break;
                            }
                            reject(new Error('NFT creation did not produce a game transaction'));
                            return _context8.a(2);
                          case 2:
                            _context8.n = 3;
                            return _this3.mod.addGame(result.tx, {
                              source: 'nft',
                              title: ((_ctx$game_data = ctx.game_data) === null || _ctx$game_data === void 0 ? void 0 : _ctx$game_data.name) || ctx.file_name,
                              id: result.nft_id || result.signature || result.tx.signature
                            });
                          case 3:
                            resolve({
                              source: 'nft',
                              result: result
                            });
                            _context8.n = 5;
                            break;
                          case 4:
                            _context8.p = 4;
                            _t3 = _context8.v;
                            reject(_t3 instanceof Error ? _t3 : new Error(String(_t3)));
                          case 5:
                            return _context8.a(2);
                        }
                      }, _callee8, null, [[0, 4]]);
                    }));
                    function callback(_x10) {
                      return _callback4.apply(this, arguments);
                    }
                    return callback;
                  }()
                });
              });
            case 2:
              return _context9.a(2, _context9.v);
          }
        }, _callee9, this);
      }));
      function open_create_nft(_x1) {
        return _open_create_nft.apply(this, arguments);
      }
      return open_create_nft;
    }()
  }]);
}();
module.exports = LibraryOverlay;